import { $, $$ } from 'utils/dom';
import Shower from '../shower';

export default class Filter {
  constructor(props) {
    this.container = props.container;
    this.filter = props.filter;
    this.filterShower = null;
    this.items = props.items;
    this.itemContainer = this.items[0].parentNode;
    this.hiddenClass = props.hiddenClass || 'item-hidden';
    this.activeClass = props.activeClass || 'item--active';
    this.itemLinkClassName = props.itemLinkClassName;
    this.loadMoreNode = props.loadMoreNode;
    this.defaultItemsToShow = props.defaultItemsToShow || 4;
    this.amountOfItemsToShow = props.amountOfItemsToShow || 4;
    this.activeItems = [];
    this.onItemRendered = props.onItemRendered;
  }

  filterItems = () => {
    this.resets();

    this.itemContainer.setAttribute('data-updating', true);
    if (this.filter) {
      const selectedOption = $('.o-filter__button', this.filter).textContent;

      setTimeout(() => {
        this.items.forEach(item => {
          const filterData = item.dataset.year;

          if (
            selectedOption === 'All' ||
            selectedOption === 'Alle' ||
            selectedOption === 'Filter' ||
            selectedOption === filterData
          ) {
            this.showItem(item);
          } else {
            this.hideItem(item);
          }
        });
        this.loadMoreNode && this.hideItemsForLoadMore();

        this.itemContainer.removeAttribute('data-updating');
      }, 75);
    } else {
      this.activeItems = this.items;
      this.loadMoreNode && this.hideItemsForLoadMore();
      this.itemContainer.removeAttribute('data-updating');
    }
  };

  initFilter = () => {
    const filterButton = $('.o-filter__button', this.filter);
    const filterOptionsList = $('.o-filter__options-list', this.filter);
    const options = new Set();

    filterButton.textContent = 'Filter';

    document.documentElement.lang.substring(0, 2) === 'de'
      ? options.add('Alle')
      : options.add('All');

    this.items.forEach(item => options.add(item.dataset.year));

    options.forEach((option, index) => {
      // <li class="o-filter__option" tabindex="0" role="option">${option}</li>
      const listOptionNode = document.createElement('li');
      listOptionNode.setAttribute('role', 'option');
      listOptionNode.setAttribute('tabindex', '0');
      listOptionNode.classList.add('o-filter__option');
      listOptionNode.textContent = option;
      filterOptionsList.appendChild(listOptionNode);

      listOptionNode.addEventListener('click', () => {
        this.selectOption(listOptionNode, index);
        this.filterItems();
      });
      listOptionNode.addEventListener('keydown', e => {
        if (e.key === ' ' || e.key === 'Enter') {
          this.selectOption(listOptionNode, index);
          filterButton.focus();
          this.filterItems();
        }
      });
    });

    this.filterShower = new Shower({
      target: $('.o-filter__options-wrapper'),
      handler: filterButton,
      easing: 'ease',
      duration: 250,
      initOpened: false,
      openClassName: 'is-open',
    });
    this.filterShower.init();
  };

  selectOption = (optionNode, nodeIndex) => {
    const filterButton = $('.o-filter__button', this.filter);

    filterButton.setAttribute('data-selected-index', nodeIndex);
    filterButton.textContent = optionNode.textContent;
    this.filterShower.close();
  };

  resets = () => {
    this.activeItems = []; // reset array
    this.items.forEach(item => {
      item.removeAttribute('data-hide');

      if ($$('a', item).length) {
        $$('a', item).map(link => link.removeAttribute('tabindex'));
      }
    });
  };

  showItem = item => {
    item.classList.add(this.activeClass);
    item.classList.remove(this.hiddenClass);
    this.activeItems.push(item);

    if ($$('a', item).length) {
      $$('a', item).map(link => link.removeAttribute('tabindex'));
    }

    this.onItemRendered && this.onItemRendered(item);
  };

  hideItem = item => {
    item.classList.add(this.hiddenClass);
    item.classList.remove(this.activeClass);
    item.removeAttribute('data-hide');

    if ($$('a', item).length) {
      $$('a', item).map(link => link.setAttribute('tabindex', '-1'));
    }
  };

  hideItemsForLoadMore = () => {
    this.activeItems.forEach((item, i) => {
      if (i > this.defaultItemsToShow - 1) {
        item.setAttribute('data-hide', 'true');

        this.itemLinkClassName &&
          $$(`${this.itemLinkClassName}`, item).map(item =>
            item.setAttribute('tabindex', '-1')
          );
      } else {
        this.onItemRendered && this.onItemRendered(item);
      }
    });

    if (this.loadMoreNode) {
      if (this.activeItems.length <= this.defaultItemsToShow) {
        this.loadMoreNode.classList.add('review__btn--hidden');
      } else {
        this.loadMoreNode.classList.remove('review__btn--hidden');
      }
    }
  };

  showMore = () => {
    const hiddenItems = [];
    this.items.forEach(item => {
      if (item.getAttribute('data-hide')) {
        hiddenItems.push(item);
      }
    });

    hiddenItems.forEach((item, i) => {
      if (i < this.amountOfItemsToShow) {
        this.itemLinkClassName &&
          $$(`${this.itemLinkClassName}`, item).map(item =>
            item.removeAttribute('tabindex')
          );

        item.classList.remove(this.hiddenClass);
        item.removeAttribute('data-hide');

        this.onItemRendered && this.onItemRendered(item);
      }
    });

    hiddenItems.splice(0, this.amountOfItemsToShow);
    hiddenItems.length === 0 &&
      this.loadMoreNode.classList.add('review__btn--hidden');
  };

  bindEvents = () => {
    /* eslint-disable no-unused-expressions */
    this.loadMoreNode?.addEventListener('click', this.showMore);
    /* eslint-enable */
  };

  init = () => {
    !this.loadMoreNode && (this.activeItems = this.items);
    if (this.filter) this.initFilter();
    this.loadMoreNode && this.filterItems();
    this.bindEvents();
    if (!this.loadMoreNode && this.onItemRendered) {
      this.items.forEach(item => this.onItemRendered(item));
    }
  };
}
